import Hero from "@/components/Hero";
import SeoHead from "@/components/SeoHead";

export default function ThankYouPage() {
  const page = {
    title: {
      path: "thankyou.hero.title",
      placeholder: "Thank you for your inquiry",
    },
    path: "thankyou.hero.text",
    background: {
      path: "thankyou.hero.image"
    }
  }
  return (
    <>
      <SeoHead title="Thank You" canonical="/thank-you" />
      <Hero background={page.background} title={page.title} path={page.path} />
    </>
  );
}
